import * as React from 'react';

const QrCodeSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd">
            <path
                fillRule="nonzero"
                d="M22 2.5V9h-1V3h-6V2h7v.5zM2 16h1v5H2v-5zm0 6v-1h7v1H2zM3 3V2h6v1H3zM2 2h1v7H2V2zm20 .5V3h-1V2h1v.5zM21 16h1v5h-1v-5zm-6 6v-1h7v1h-7zM5 5h3v3H5V5zm11 0h3v3h-3V5zM5 16h3v3H5v-3zm5 2v-1h2v1h-2zm0-8V9h2v1h-2zm-1 2v-1h2v1H9zm5 7v-1h2v1h-2zm4-3v-1h1v1h-1zm-6 0h1v2h-1v-2zm2 0h1v2h-1v-2zm1 1v-1h2v1h-2zm3 0h1v1h-1v-1zm0 1h1v1h-1v-1zm-1 0h1v1h-1v-1zm-2-3h1v1h-1v-1zm-2-3h1v2h-1v-2zm1 1v-1h2v1h-2zm0-2h1v1h-1v-1zm0-4h1v1h-1V7zm0 1h1v1h-1V8zm-4-2h1v1h-1V6zM9 17h1v1H9v-1zm4-9h1v1h-1V8zm3 2h1v1h-1v-1zm-5 2h1v1h-1v-1zm7 0h1v1h-1v-1zm-2 0h1v1h-1v-1zm-1 1h1v1h-1v-1zm1 0h1v1h-1v-1zM7 9h1v1H7V9zm0 1h1v1H7v-1zM6 9h1v1H6V9zm11 0h1v1h-1V9zm-5-4h1v1h-1V5zm5 12h1v1h-1v-1zm-7-2h1v1h-1v-1zm0-1h1v1h-1v-1zm1 0h1v1h-1v-1zm-4 0h1v1H7v-1zm1 0h1v1H8v-1zm-3-2h1v1H5v-1zm1 0h1v1H6v-1zm0 1h1v1H6v-1zm1 0h1v1H7v-1zm1 0h1v1H8v-1zm2 5h1v1h-1v-1zm1-11h1v1h-1V7zM9 8h1v1H9V8zm0 1h1v1H9V9z"
            />
        </g>
    </svg>
);

QrCodeSvg.displayName = 'QrCodeSvg';
export default QrCodeSvg;
